<template>
  <div class="templatebody" :style="note">
    <div>
      <heard></heard>
    </div>
    <div class="flex-jucenter margin-top-ls">
      <p class="text-white sl-p">用户登录 - 欢迎您来到云航迹</p>
    </div>
    <div class="margin-top-l flex-jucenter">
      <el-form
        ref="form"
        :model="form"
        label-position="left"
        label-width="0.2604166666666667rem "
        style="width: 1.9791666666666667rem "
      >
        <el-form-item label="账号">
          <el-input placeholder="请输入您的账号" v-model="user"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="pass">
          <el-input
            type="password"
            placeholder="请输入登录密码"
            v-model="password"
            @keydown.enter.native="tiaozhuan()"
          ></el-input>
        </el-form-item>
        <el-form-item label=" " prop="text">
          <el-button
            class="text-white width-100 btn"
            type="primary"
            @click="tiaozhuan()"
          >
            登 录 <i class="el-icon-s-promotion el-icon--right"></i>
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- <div>
      <p class="login-fotget">忘记密码?</p>
    </div> -->
    <div class="buttom-text">
      <p >
        版权所有：海南云航翊信息科技有限责任公司 Copyright © 2014.Company name All
        rights reserved.
      </p>
    </div>
  </div>
</template>

<script>
import "@/assets/css/home.css";
import "@/assets/css/public.css";
import heard from "../public/heard.vue";
export default {
  name: "Home",
  components: {
    heard,
  },
  data() {
    return {
      textarea: "",
      note: {
        backgroundImage:
          "url(" + require("../../assets/img/bg-login.jpg") + ")",
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%",
      },
      user: "",
      password: "",
      form: {},
    };
  },
  mounted() {},
  methods: {
    
    tiaozhuan() {
      if (this.user.length == 0) {
        this.$message({
          showClose: true,
          message: "请填写账号",
          type: "warning",
        });
        return;
      } else if (this.password.length == 0) {
        this.$message({
          showClose: true,
          message: "请填写密码",
          type: "warning",
        });
        return;
      } else {
        let data ={
           account_name: this.user,
            password: this.password,
        }
        // data = JSON.stringify(data)
        this.$source
          .post("/v1/servicer/login", data)
          .then((res) => {
            if (res.body.code == 22200) {
              localStorage.setItem("userInfo", JSON.stringify(res.body.data));
              this.$router.push("../user/ordermanage");
            } else {
              this.$message({
                showClose: true,
                message: res.body.message,
                type: "warning",
              });
            }
          })
          .catch((err) => {});
      }

      // console.log(this.user,this.password,333333);
      //           this.$router.push('../user/ordermanage')
    },
  },
};
</script>
<style scoped>
.el-button--primary {
  background-color: #fd9405;
  border-color: #fd9405;
  font-size: 18px;
}

.el-button--primary:hover {
  background-color: #fd9405;
  border-color: #fd9405;
}

.el-button--primary:focus {
  background-color: #fd9405;
  border-color: #fd9405;
}

.el-form--label-left /deep/ .el-form-item__label {
  color: #fff;
}
i {
  font-size: 0.102917rem;
  color: #ffffff;
  margin-left: 0.1rem;
}
.templatebody {
  min-height: 95vh;
}
.text-white {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/log/login.vue